import React from 'react';

import CompanyConfigurationService from '../../../services/CompanyConfiguration';

function SerialByCompany({ asset }) {
  const { COMPANY_CONFIGURATIONS_TYPES, companyConfigurations } = CompanyConfigurationService
  const hideSerial = companyConfigurations.find(x => x.key === COMPANY_CONFIGURATIONS_TYPES.HIDE_ASSET_SERIAL)

  if (!asset.serial || hideSerial) {
    return null
  }

  return (
    <li className="list-group-item">
      <b>Serial</b>: {asset.serial}
    </li>
  )
}

export default SerialByCompany



// WEBPACK FOOTER //
// ./src/component/Asset/serial/SerialByCompany.js